export const LOADED = 'REQUEST_PARAM_LOADED';
